import React, { useEffect } from 'react';

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="dark-page">
      <section className="legal-hero">
        <div className="section-tag">LEGAL DOCUMENTATION</div>
        <h1 className="defense-headline" style={{ fontSize: '56px' }}>Terms of Service</h1>
        <p className="defense-description">Last Updated: December 2025</p>
      </section>

      <section className="legal-content">
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '60px 20px' }}>
          <div className="legal-section">
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#D4AF37', marginBottom: '20px' }}>1. Scope of Services</h2>
            <p style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginBottom: '30px' }}>
              Labana Dynamics OÜ provides advanced defense technology solutions including the Wolf Eye drone interceptor module. All services are subject to:
            </p>
            <ul style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginLeft: '20px', marginBottom: '30px' }}>
              <li>Valid government or defense organization authorization</li>
              <li>Compliance with international arms regulations</li>
              <li>Executed Master Service Agreement (MSA) or purchase order</li>
              <li>Security clearance verification for classified specifications</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#D4AF37', marginBottom: '20px' }}>2. Quote Requests</h2>
            <p style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginBottom: '30px' }}>
              Territory protection calculator quotes are estimates only. Final pricing requires:
            </p>
            <ul style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginLeft: '20px', marginBottom: '30px' }}>
              <li>Site survey and operational assessment</li>
              <li>Threat analysis and deployment modeling</li>
              <li>Integration requirements with existing systems</li>
              <li>Logistics and installation planning</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#D4AF37', marginBottom: '20px' }}>3. Restricted Use</h2>
            <p style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginBottom: '20px' }}>
              Wolf Eye systems are classified defense articles and are subject to:
            </p>
            <ul style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginLeft: '20px', marginBottom: '30px' }}>
              <li>ITAR (International Traffic in Arms Regulations)</li>
              <li>EAR (Export Administration Regulations)</li>
              <li>EU dual-use export controls</li>
              <li>End-user certification requirements</li>
            </ul>
            <p style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginBottom: '30px' }}>
              Unauthorized transfer, reverse engineering, or non-approved deployment is strictly prohibited and punishable under international law.
            </p>
          </div>

          <div className="legal-section">
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#D4AF37', marginBottom: '20px' }}>4. Warranty and Liability</h2>
            <p style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginBottom: '30px' }}>
              All systems include:
            </p>
            <ul style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginLeft: '20px', marginBottom: '30px' }}>
              <li>24-month manufacturer warranty on hardware</li>
              <li>90-day software update support</li>
              <li>Field service for critical failures during active deployments</li>
            </ul>
            <p style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginBottom: '30px' }}>
              Labana Dynamics is not liable for operational failures resulting from improper deployment, environmental damage beyond specifications, or misuse.
            </p>
          </div>

          <div className="legal-section">
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#D4AF37', marginBottom: '20px' }}>5. Force Majeure</h2>
            <p style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginBottom: '30px' }}>
              Labana Dynamics is not responsible for delays or failures due to armed conflict, government sanctions, supply chain disruption, or other events beyond reasonable control.
            </p>
          </div>

          <div className="legal-section">
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#D4AF37', marginBottom: '20px' }}>6. Governing Law</h2>
            <p style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginBottom: '10px' }}>
              These terms are governed by the laws of the Republic of Estonia. Disputes shall be resolved through arbitration in Tallinn, Estonia, under ICC rules.
            </p>
          </div>

          <div className="legal-section">
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#D4AF37', marginBottom: '20px' }}>7. Contact</h2>
            <p style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.8', marginBottom: '10px' }}>
              For legal or contract inquiries:
            </p>
            <p style={{ fontSize: '16px', color: '#D4AF37', lineHeight: '1.8' }}>
              Email: info@labanadynamics.com<br/>
              Subject: Legal - Terms of Service
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;